const localLang: string = process.env.LANG || 'en'

// 首字母大写
export function capitalize(str = '') {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function sleep(time: number) {
  return new Promise(resolve => setTimeout(resolve, time))
}

// 本地化价格
export function localPriceFormat(value: number): string {
  if (value === undefined || value === null) {
    return ''
  }
  let resultValue = String(value)
  if (localLang === 'ja') {
    const num = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(value / 100)
    resultValue = num.slice(1)
  } else {
    const num = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value / 100)
    resultValue = num.slice(1)
  }
  return resultValue
}
// 生成 codeVerifier
export function getCodeVerifier(): string {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_-'
  let codeVerifier = ''
  const charsetLength = charset.length
  const length = 64

  // Randomly generate the string
  for (let i = 0; i < length; i++) {
    codeVerifier += charset.charAt(Math.floor(Math.random() * charsetLength))
  }

  return codeVerifier
}
